import defaultV2Client from '@/plugins/axios/defaultV2Client'
import qs from 'query-string'

export default {
  /**
   * 사용자 정의 입금명 목록
   * @param {*} query { isActive: Boolean }
   * @returns
   */
  getUsersExtraDepositNames(query) {
    return defaultV2Client.get(`/users/extra-deposit-names?${qs.stringify(query)}`)
  },
}
